import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/modules/auth';
import notification from '@/store/modules/notification';
import account from '@/store/modules/account';
import wideband from '@/store/modules/wideband';
import pbxware from '@/store/modules/pbxware';
import admin from '@/store/modules/admin';
import freeradius from '@/store/modules/freeradius';
import postfix from '@/store/modules/postfix';
import sms from '@/store/modules/sms';
import tpp from '@/store/modules/tpp';
import sip from '@/store/modules/sip';
import aws from '@/store/modules/aws';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
    state: {
        headerSuccessMessage: null,
        headerErrorMessage: null,
        loading: false,
        leftOpen: true,
        rightOpen: false,
        preloader: true,
        modal: {},
        showModal: false,
        leftSideRoutes: [],
    },
    getters: {
        headerSuccessMessage: state => state.headerSuccessMessage,
        headerErrorMessage: state => state.headerErrorMessage,
        loading: state => state.loading,
        modal: state => state.modal,
        showModal: state => state.showModal,
        leftSideRoutes: state => state.leftSideRoutes,
        leftOpen: state => state.leftOpen,
    },
    mutations: {
        setHeaderSuccessMessage(state, message) {
            state.headerSuccessMessage = message;
        },
        setHeaderErrorMessage(state, message) {
            state.headerErrorMessage = message;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setModal(state, modal) {
            state.modal = modal;
        },
        setShowModal(state, payload) {
            state.showModal = payload;
        },
        sortLeftSideRoutes(state) {
            const sort = (items) => {
                const sorted = items.sort((a, b) => (a.meta.label.toLowerCase() > b.meta.label.toLowerCase()) ? 1 : ((b.meta.label.toLowerCase() > a.meta.label.toLowerCase()) ? -1 : 0));

                return sorted.map(item => {
                    if (item.children && item.children.length) {
                        item.children = sort(item.children);
                    }

                    return item;
                });
            }

            state.leftSideRoutes = sort(state.leftSideRoutes);
        },
        updateLeftSideRoutesChildren(state, payload) {
            const components = {
                'vmware.vcenter.index': () => import('@/views/vmware/vcenter/Index.vue'),
                'vmware.vcenter.virtualMachine': () => import('@/views/vmware/vcenter/VirtualMachine.vue'),
                'vmware.vcenter.dataCenter': () => import('@/views/vmware/vcenter/DataCenter.vue'),
                'vmware.vcenter.dataStore': () => import('@/views/vmware/vcenter/DataStore.vue'),
                'vmware.vcenter.host': () => import('@/views/vmware/vcenter/Host.vue'),
                'vmware.vcenter.network': () => import('@/views/vmware/vcenter/Network.vue'),
            };

            const update = (children) => {
                return children.map(item => {
                    if (item.children && item.children.length > 0) {
                        item.children = update(item.children);
                    }

                    if (item.name == payload.parent.name) {
                        item.children = update(payload.children);
                    }

                    if (typeof item.component == 'string') {
                        item.component = components[item.component];
                    }

                    return item;
                });
            }

            state.leftSideRoutes = state.leftSideRoutes.map(item => {
                if (item.children && item.children.length > 0) {
                    item.children = update(item.children);
                }

                return item;
            });

            payload.router.addRoutes(state.leftSideRoutes);

            this.commit('sortLeftSideRoutes');
        },
        addLeftSideRoutes(state, routes) {
            routes.forEach((i) => {
                if (
                    state.leftSideRoutes.findIndex((j) => { return j.meta.label == i.meta.label }) === -1 && 
                    i.meta.group == 'leftSidebar'
                ) {
                    state.leftSideRoutes.push(i);
                }
            });

            const filter = (item) => {
                return item.filter(child => {
                    if (child.children) {
                        child.children = filter(child.children);
                    }

                    if (
                        (child.meta.permission && state.auth.user.permissions.findIndex(k => k.name === child.meta.permission) !== -1) || 
                        !child.meta.permission ||
                        state.auth.user.roles.findIndex(role => role.name === 'Super Admin') !== -1
                    ) {
                        return true;
                    }
                });
            }

            state.leftSideRoutes = state.leftSideRoutes.filter(item => {
                if (item.children) {
                    item.children = filter(item.children)
                }

                if (
                    (item.meta.permission && state.auth.user.permissions.findIndex(k => k.name === item.meta.permission) !== -1) || 
                    !item.meta.permission ||
                    state.auth.user.roles.findIndex(role => role.name === 'Super Admin') !== -1
                ) {
                    return true;
                }

                return false;
            }).filter(item => {
                if (item.children && item.children.length === 0) {
                    return false;
                }

                return true;
            });

            this.commit('sortLeftSideRoutes');
        },
        left_menu(state, option) {
            if (option == "open") {
                state.leftOpen = true
            } else if (option == "close") {
                state.leftOpen = false
            } else if (option == "toggle") {
                state.leftOpen = !state.leftOpen
            }
            if (state.leftOpen) {
                document.getElementsByTagName("body")[0].classList.remove("left-hidden")
            } else {
                document.getElementsByTagName("body")[0].classList.add("left-hidden")
            }
        },
        rightside_bar(state, option) {

            if (option == "open") {
                state.rightOpen = true;

            } else if (option == "close") {
                state.rightOpen = false;

            } else if (option == "toggle") {
                state.rightOpen = !state.rightOpen;
            }
            if (state.rightOpen) {
                document.getElementsByTagName("body")[0].classList.add("sidebar-right-opened");
                document.getElementById("right-side").classList.add("right-active");
            } else {
                document.getElementsByTagName("body")[0].classList.remove("sidebar-right-opened");
                document.getElementById("right-side").classList.remove("right-active");
            }
        }
    },
    modules: {
        auth,
        notification,
        account,
        wideband,
        pbxware,
        admin,
        freeradius,
        postfix,
        sms,
        tpp,
        sip,
        aws,
    },
    strict: debug
})

export default store